module.exports = __webpack_public_path__ + "img/primary_7x4_z18.3f48fd9a.svg";